"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AbstractService2 = _interopRequireDefault(require("../../../AbstractService"));

var _IrwStoreAvailabilityParser = _interopRequireDefault(require("./IrwStoreAvailabilityParser"));

var _ServiceUrlUtility = _interopRequireDefault(require("../../../util/ServiceUrlUtility"));

var _ServiceException = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/exception/ServiceException"));

var _ServiceSettings = _interopRequireDefault(require("../../../ServiceSettings"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var SERVICE_PATH = '/retail/iows/{apiLocalePath}/stores/{storeId}/availability/';
/**
 * This class is used to fetch and parse store availability data for IRW.
 */

var IrwStoreAvailabilityService = /*#__PURE__*/function (_AbstractService) {
  _inherits(IrwStoreAvailabilityService, _AbstractService);

  var _super = _createSuper(IrwStoreAvailabilityService);

  /**
   * Class constructor.
   */
  function IrwStoreAvailabilityService() {
    var _this;

    _classCallCheck(this, IrwStoreAvailabilityService);

    _this = _super.call(this);
    _this.serviceVersion = '1.0';
    return _this;
  }
  /**
   * Fetches and returns availability for an item.
   *
   * @param {String} apiLocalePath API locale path. Example: "gb/en".
   * @param {String} storeId Store ID.
   * @param {Object} item Item to use.
   * @param {String} item.type Item type.
   * @param {Number} item.id Item id.
   * @return {Promise} Promise object.
   */


  _createClass(IrwStoreAvailabilityService, [{
    key: "getAvailability",
    value: function getAvailability(apiLocalePath, storeId, item) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        fetch(_this2._getUrl(apiLocalePath, storeId, item), {
          method: 'GET',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/vnd.ikea.iows+json; version=' + _this2.serviceVersion,
            Contract: _ServiceSettings.default.contract.toString(),
            Consumer: _ServiceSettings.default.consumer
          }
        }).then(_this2._handleJsonResponse.bind(_this2)).then(function (data) {
          var parsedData = _this2._parse(data);

          if (parsedData) {
            resolve(parsedData);
          } else {
            reject(new _ServiceException.default('Failed to parse stock availability data. Data in response was not valid.', _this2.constructor.factoryName));
          }
        }).catch(_this2._rejectWrapper.bind(_this2, reject));
      });
    }
    /**
     * Returns the URL to use for the service.
     *
     * @param {String} apiLocalePath API locale path. Example: "gb/en".
     * @param {String} storeId Store ID.
     * @param {Object} item Item to use.
     * @param {String} item.type Item type.
     * @param {Number} item.id Item id.
     * @return {Number} Calculated height.
     */

  }, {
    key: "_getUrl",
    value: function _getUrl(apiLocalePath, storeId, item) {
      if (!item || !item.id || !item.type) {
        throw new _ServiceException.default('Missing one of the following mandadory properties: item.id or item.type', this.constructor.factoryName);
      }

      return _ServiceUrlUtility.default.getBaseUrl() + this._getServicePath().replace('{apiLocalePath}', apiLocalePath).replace('{storeId}', storeId) + item.type + ',' + item.id;
    }
    /**
     * Parses availability data.
     *
     * @param {Object} data Data to parse.
     * @return {Object} Parsed data.
     */

  }, {
    key: "_parse",
    value: function _parse(data) {
      return _IrwStoreAvailabilityParser.default.parse(data);
    }
    /**
     * Returns the service path to be used for the URL.
     *
     * @return {String} Service path.
     */

  }, {
    key: "_getServicePath",
    value: function _getServicePath() {
      return SERVICE_PATH;
    }
    /**
     * Returns the name used by ServiceFactory.
     *
     * @override
     * @return {String} Factory name.
     */

  }], [{
    key: "factoryName",
    get: function get() {
      return 'irwstoreavailability';
    }
  }]);

  return IrwStoreAvailabilityService;
}(_AbstractService2.default);

exports.default = IrwStoreAvailabilityService;